import CellAdministratedValidation from './CellAdministratedValidation';

export default CellAdministratedValidation;
